import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix for default icon in react-leaflet
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";

// Create and configure the default icon
const DefaultIcon = L.icon({
  iconUrl: icon,
  iconRetinaUrl: iconRetina,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Set the default icon globally
L.Marker.prototype.options.icon = DefaultIcon;

interface MapProps {
  Upi: string;
  location: [number, number];
}

const PropertyMap: React.FC<MapProps> = ({ Upi, location }) => {
  const [latitude, longitude] = location;

  // Validate location coordinates
  const isValidCoordinate = (coord: number): boolean => {
    return !isNaN(coord) && isFinite(coord);
  };

  // Fallback to a default location if coordinates are invalid
  const getValidCoordinates = (): [number, number] => {
    if (isValidCoordinate(latitude) && isValidCoordinate(longitude)) {
      return [latitude, longitude];
    }
    console.warn("Invalid coordinates provided, using default location");
    return [-1.2921, 36.8219]; // Default: Nairobi, Kenya
  };

  const validCoordinates = getValidCoordinates();
  const zoomLevel = 15;

  return (
    <div className="w-full h-[400px] my-8 rounded-lg overflow-hidden border border-gray-200 shadow-md">
      <MapContainer
        center={validCoordinates}
        zoom={zoomLevel}
        className="w-full h-full"
        scrollWheelZoom={true}
        style={{ minHeight: "400px" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          maxZoom={19}
          minZoom={3}
        />
        <Marker position={validCoordinates}>
          <Popup className="custom-popup">
            <div className="text-center">
              <div className="font-bold text-indigo-600 mb-1">
                📍 Property Location
              </div>
              <div className="text-sm">
                <span className="font-medium">UPI:</span> {Upi}
              </div>
              <div className="text-xs text-gray-500 mt-1">
                Lat: {validCoordinates[0].toFixed(6)}, Lng:{" "}
                {validCoordinates[1].toFixed(6)}
              </div>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
      
      {/* Optional: Coordinates display */}
      <div className="text-xs text-gray-500 mt-1 text-center">
        Coordinates: {validCoordinates[0].toFixed(6)}, {validCoordinates[1].toFixed(6)}
      </div>
    </div>
  );
};

export default PropertyMap;